<template>
  <div class="row q-pt-sm full-width">
    <div class="row bg-blue-1 full-width q-pl-md items-center">
      <q-btn :disabled="!is_edit" round flat color="primary" icon="fa fa-plus" @click="onAddItem" />
      <q-btn :disabled="!is_edit" round flat color="deep-orange" icon="far fa-trash-alt" @click="onRemoveAll" />

      <!-- 🔹新增：显示合计数 -->
      <div v-if="sum_field" class="q-ml-lg text-subtitle2 text-primary q-mr-md">
        {{ sum_text ? t(sum_text) + ': ' : '' }}{{ total_sum }}
      </div>
    </div>

    <q-list bordered separator class="full-width column items-start">
      <template v-for="(item, index) in my_edit_data" :key="index">
        <q-item class="full-width" v-if="item.sys_is_deleted == false">
          <q-item-section>
            <div class="row items-center content-center full-width">
              <q-separator />
              <div class="col-auto q-pr-sm blue-grey-1">
                <q-btn :disabled="!is_edit" round flat color="red" icon="fas fa-minus" @click="onRemoveItem(index)" />
              </div>
              <div class="col-grow">
                <DataEditMult v-if="item" :menu_data="my_menu_data" :my_edit_data="item" :is_edit="is_edit"
                  @onDataChange="onDataChange"></DataEditMult>
              </div>
            </div>
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
// import DataEditMult from './DataEditMult.vue';
import DataEditMult from './DataEdit.vue';
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";
import PublicFunction from "@/utils/PublicFunction.js";

export default {
  name: "EditMultData",
  props: {
    join_table: { type: String, default: "" },
    field_name: { type: String, default: "" },
    mult_data: { type: Object, default: [] },
    menu_data: { require: true, default: [] },
    is_save: { type: Boolean, default: false },
    is_edit: { type: Boolean, default: false },
    parent_id: { type: String, default: "" },

    // 🔹新增的两个参数
    sum_field: { type: String, default: "" }, // 要合计的字段名
    sum_text: { type: String, default: "" }, // 合计显示文字
  },
  emits: ['update:mult_data'],
  components: { DataEditMult },
  setup(props, context) {
    const { t } = useI18n();

    const { get_default_value } = PublicFunction;
    const my_edit_data = ref([]);
    let my_edit_data_s = [];
    const my_menu_data = ref(JSON.parse(JSON.stringify(props.menu_data)));
    let tmp_edit_data = {};
    const default_edit_data = {};
    let mult_field = Array();
    let form_structure_list = [];
    let parent_id = props.parent_id;

    my_menu_data.value['is_audit'] = 0;
    my_menu_data.value['is_detail'] = 0;
    my_menu_data.value['menu_name'] = my_menu_data.value['menu_name'] + '_' + props.field_name;
    my_menu_data.value['table_name'] = 't_' + my_menu_data.value['menu_name'];

    // 🔹计算合计值
    const total_sum = computed(() => {
      if (!props.sum_field) return 0;
      let total = 0;
      my_edit_data.value.forEach(item => {
        if (!item.sys_is_deleted && item[props.sum_field]) {
          const val = parseFloat(item[props.sum_field]);
          if (!isNaN(val)) total += val;
        }
      });

      // 返回合计数到父组件，用于更新外部字段
      context.emit("MultDataUpdateSum", total);
      return total;
    });

    watch(
      () => props.parent_id,
      (value) => {
        parent_id = value;
        get_mult_data();
      }, { immediate: true, deep: true }
    );

    function get_mult_data() {
      if (parent_id !== null) {
        request("get_mult_data", {
          menu_name: props.menu_data['menu_name'],
          parent_id: parent_id,
          field_name: props.field_name,
        }).then((res) => {
          Object.keys(res).forEach((key) => {
            my_edit_data.value = res[key];
          });

          Object.values(my_edit_data.value).forEach((item) => {
            item['sys_is_deleted'] = false;
            item['sys_field_name'] = props.field_name;
          });
          my_edit_data_s = JSON.parse(JSON.stringify(my_edit_data.value));
        });
      }
    }

    request("get_form_structure", {
      menu_name: my_menu_data.value.menu_name,
      table_name: my_menu_data.value.table_name,
      form_type: "edit",
    }).then((res) => {
      tmp_edit_data = get_default_value(res);
      mult_field = Array();
      form_structure_list = [];
      Object.values(res).forEach((item) => {
        Object.values(item).forEach((field) => {
          form_structure_list[field.field_name] = field;
          if (field.component_type == "select_mult") {
            mult_field.push(field.field_name);
            if (tmp_edit_data[field.field_name] != null) {
              tmp_edit_data[field.field_name] = JSON.parse("[" + tmp_edit_data[field.field_name] + "]");
            }
          }
        });
      });
      default_edit_data.value = JSON.parse(JSON.stringify(tmp_edit_data));
    });

    const onAddItem = () => {
      let temp_item = JSON.parse(JSON.stringify(default_edit_data.value));
      temp_item["id"] = "item_" + my_edit_data.value.length + "_" + Math.round(Math.random() * 10000);
      temp_item["sys_is_deleted"] = false;
      temp_item['sys_field_name'] = props.field_name;
      my_edit_data.value.unshift(temp_item);
    };

    const onRemoveItem = (index) => {
      if (my_edit_data.value[index]["id"].substring(0, 5) == "item_") {
        my_edit_data.value.splice(index, 1);
      } else {
        my_edit_data.value[index]['sys_is_deleted'] = true;
      }
    };

    const onRemoveAll = () => {
      my_edit_data.value.forEach((item, index) => {
        if (item.id.startsWith("item_")) {
          my_edit_data.value.splice(index, 1);
        } else {
          item.sys_is_deleted = true;
        }
      });
    };

    watch(
      () => props.is_save,
      (value) => {
        if (value) {
          const modifiedItems = [];
          my_edit_data.value.forEach((item) => {
            const correspondingItem = my_edit_data_s.find((item_s) => item_s.id === item.id);
            if (correspondingItem) {
              const propertiesToCompare = Object.keys(item);
              const isModified = propertiesToCompare.some((property) => correspondingItem[property] !== item[property]);
              if (isModified) {
                modifiedItems.push(item);
                item['sys_is_modified'] = true;
                correspondingItem['sys_is_modified'] = true;
              } else {
                item['sys_is_modified'] = false;
                correspondingItem['sys_is_modified'] = false;
              }
            }
          });

          request("check_validity_mult", {
            table_name: my_menu_data.value.table_name,
            save_data: my_edit_data.value,
          }).then((res) => {
            if (res.err_code == 0) {
              context.emit("SaveMultData", my_edit_data.value, props.field_name);
            } else {
              context.emit("ShowMultDataMsg", res, props.field_name);
              context.emit("SaveMultData", false, props.field_name);
            }
          });
        }
      }
    );

    function onDataChange(data) {
      if (data.hasOwnProperty('is_default') && data.is_default == "1") {
        my_edit_data.value.forEach((row) => {
          if (row !== data) row.is_default = "0";
        });
      }
    }

    return {
      t,

      my_edit_data,
      my_menu_data,
      onAddItem,
      onRemoveItem,
      onRemoveAll,
      onDataChange,
      total_sum, // 🔹暴露计算属性
      sum_field: props.sum_field,
      sum_text: props.sum_text,
    };
  },
};
</script>
